(function () {
  'use strict';
  var header = document.querySelector('.site-header');
  if (!header) return;
  var toggle = header.querySelector('[data-nav-toggle]');
  var navigation = header.querySelector('#site-navigation');
  if (!toggle || !navigation) return;
  var label = toggle.querySelector('[data-nav-label]');
  var mobile = window.matchMedia('(max-width: 1000px)');
  var open = false;

  function setOpen(next, returnFocus) {
    open = Boolean(next && mobile.matches);
    header.toggleAttribute('data-nav-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    if (label) label.textContent = open ? 'Close' : 'Menu';
    if (returnFocus && mobile.matches) toggle.focus({ preventScroll: true });
  }

  // The server renders the collapsed state before first paint. A noscript
  // style exposes the links when JavaScript is disabled. Menus are overlays,
  // so initialization/opening never changes the header or demo measurements.
  header.setAttribute('data-nav-ready', '');
  setOpen(false);
  toggle.addEventListener('click', function () { setOpen(!open); });
  header.addEventListener('click', function (event) {
    if (event.target.closest('a[href]')) setOpen(false);
  });
  // A tap outside the open menu only closes it. Captured and consumed, so the
  // same tap does not also follow a link or press a button under the finger.
  document.addEventListener('click', function (event) {
    if (!open || header.contains(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
    setOpen(false);
  }, true);
  document.addEventListener('keydown', function (event) {
    if (open && event.key === 'Escape') {
      event.preventDefault();
      setOpen(false, true);
    }
  });
  header.addEventListener('focusout', function () {
    window.setTimeout(function () {
      if (open && !header.contains(document.activeElement)) setOpen(false);
    }, 0);
  });
  function onSizeChange() { setOpen(false); }
  if (mobile.addEventListener) mobile.addEventListener('change', onSizeChange);
  else if (mobile.addListener) mobile.addListener(onSizeChange);
  window.addEventListener('pagehide', function () { setOpen(false); });
})();
